import { Root } from 'layouts/Root';
import { BrowserRouter, Route } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import { Home, NotFound, CategoryView, DashboardView } from 'views';
import { Category } from 'layouts';
import './App.scss';
import { PrivateRoute } from 'components/PrivateRoute';
import React, { MouseEventHandler, useState } from 'react';
import { Fish, Fruit, Breakfast, MilkDiary, OrganicFood, Honey, Pickle, SportsFitness, BeautyHealth, PetCare, BabyCare, Drinks, HouseHold, JamJelly, SnacksInstant, BiscuitsCakes, FreshSeaFood, CookingEssentials } from "assets"

export interface IAppProps { };

export interface authProps {
  auth_type: string
  auth_name: string
  auth_title: string
  auth_button: string
  auth_comment: string
  auth_comment_name: string
}

export interface AppContextType {
  show: boolean
  SetShow: React.Dispatch<React.SetStateAction<boolean>>
  setAuth_properties: React.Dispatch<React.SetStateAction<authProps>>
  auth_properties: authProps
  categoryShow: boolean
  SetCategoryShow: React.Dispatch<React.SetStateAction<boolean>>
  showLogin: boolean
  SetShowLogin: React.Dispatch<React.SetStateAction<boolean>>
  handleCloseCart: MouseEventHandler<HTMLDivElement>
  handleCloseCategory: MouseEventHandler<HTMLDivElement | HTMLAnchorElement>
  cat_sub_cat: {
    name: string,
    sub_cat: string[],
    img: string,
  }[]
}


export const AppContext = React.createContext<AppContextType>({
  show: false,
  SetShow: () => { },
  categoryShow: false,
  SetCategoryShow: () => { },
  showLogin: false,
  SetShowLogin: () => { },
  auth_properties: {
    auth_type: 'login',
    auth_name: 'Login',
    auth_title: 'Login with your email and password',
    auth_button: 'login',
    auth_comment: 'Not have an account?',
    auth_comment_name: 'register',
  },
  setAuth_properties: () => { },
  handleCloseCart: () => { },
  handleCloseCategory: () => { },
  cat_sub_cat: [{ name: '', sub_cat: [''], img: '' }]
})


function App(props: IAppProps) {
  const [show, SetShow] = useState<boolean>(false)
  const [showLogin, SetShowLogin] = useState<boolean>(false)
  const [categoryShow, SetCategoryShow] = useState<boolean>(false)
  const [destination, setDestination] = useState('')
  // authentication
  const [auth_properties, setAuth_properties] = useState<authProps>({
    auth_type: 'login',
    auth_name: 'Login',
    auth_title: 'Login with your email and password',
    auth_button: 'login',
    auth_comment: 'Not have an account?',
    auth_comment_name: 'register',
  })

  let cat_sub_cat = [
    {
      name: 'fish & meat',
      sub_cat: [
        'fish',
        'meat'
      ],
      img: Fish
    },
    {
      name: 'fruits & vegetable',
      sub_cat: [
        'dry fruits',
        'fresh fruits',
        'fresh vegetable'
      ],
      img: Fruit
    },
    {
      name: 'breakfast',
      sub_cat: [
        'bread',
        'cereal',
        'drinks'
      ],
      img: Breakfast
    },
    {
      name: 'milk & dairy',
      sub_cat: [
        'dairy',
        'ice cream',
        'butter & ghee'
      ],
      img: MilkDiary
    },
    {
      name: 'organic food',
      sub_cat: [
        'organic food',
      ],
      img: OrganicFood
    },
    {
      name: 'honey',
      sub_cat: [
        'honey',
      ],
      img: Honey
    },
    {
      name: 'sauses & pickles',
      sub_cat: [
        'sauses',
        'pickles & condiments',
      ],
      img: Pickle
    },
    {
      name: 'jam & jelly',
      sub_cat: [
        'jam',
        'jelly',
      ],
      img: JamJelly
    },
    {
      name: 'snacks & instant',
      sub_cat: [
        'chocolate',
        'chips & nuts',
        'canned food'
      ],
      img: SnacksInstant
    },
    {
      name: 'biscuits & cakes',
      sub_cat: [
        'biscuits',
        'cakes'
      ],
      img: BiscuitsCakes
    },
    {
      name: 'household tools',
      sub_cat: [
        'cleaner',
        'laundry',
        'air freshener'
      ],
      img: HouseHold
    },
    {
      name: 'baby care',
      sub_cat: [
        'baby food',
        'baby accessories',
      ],
      img: BabyCare
    },
    {
      name: 'fresh seafood',
      sub_cat: [
        'fresh seafood',
      ],
      img: FreshSeaFood
    },
    {
      name: 'cooking essentials',
      sub_cat: [
        'oil',
        'rice',
        'flour'
      ],
      img: CookingEssentials
    },
    {
      name: 'drinks',
      sub_cat: [
        'tea',
        'water',
        'juice'
      ],
      img: Drinks
    },
    {
      name: 'pet & care',
      sub_cat: [
        'dry fruits',
        'fresh fruits',
        'fresh vegetable'
      ],
      img: PetCare
    },
    {
      name: 'beauty & health',
      sub_cat: [
        'bath',
        'cosmetics',
        'oral care'
      ],
      img: BeautyHealth
    },
    {
      name: 'sports & fitness',
      sub_cat: [
        'sports',
        'fitness',
      ],
      img: SportsFitness
    },
  ]

  function handleCloseCart(): void {
    SetShow(!show)
  }

  function handleCloseCategory(): void {
    SetCategoryShow(!categoryShow)
  }




  return <AppContext.Provider value={{
    show,
    SetShow,
    handleCloseCart,
    handleCloseCategory,
    categoryShow,
    SetCategoryShow,
    showLogin,
    SetShowLogin,
    cat_sub_cat,
    auth_properties,
    setAuth_properties
  }}>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Root />}>
          <Route index element={<Home />} />
          <Route path='/login' element={<Home />} />
          <Route path='/register' element={<Home />} />
          <Route path='/forgot-password' element={<Home />} />

          <Route element={<PrivateRoute />}>
            <Route path='/dashboard' element={<DashboardView />} />
          </Route>
          <Route path='category' element={<Category />}>
            <Route path=':cat_name'>
              <Route index element={<CategoryView />} />
              <Route path='sub-category' element={<CategoryView />}>
                <Route path=':sub_cat_name' element={<CategoryView />} />
              </Route>
            </Route>
          </Route>
          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </AppContext.Provider>
}

export default App;
